import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { Avatar } from '../styles/GlobalStyles';
import { FiPhone, FiX } from 'react-icons/fi';

export default function MissedCallsNotifications() {
  const { state, dispatch } = useApp();
  const [usersById, setUsersById] = useState({});

  const missed = Object.entries(state.missedCallsByUser || {})
    .filter(([_, count]) => Number(count) > 0)
    .map(([id, count]) => ({ userId: Number(id), count: Number(count) }))
    .filter(x => !Number.isNaN(x.userId));

  useEffect(() => {
    if (!missed.length) return;
    // если уже есть данные по всем пользователям — не грузим
    const needFetch = missed.some(m => !usersById[m.userId]);
    if (!needFetch) return;

    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch('/api/users', {
          headers: { Authorization: `Bearer ${token}` }
        });
        const list = await res.json();
        if (Array.isArray(list)) {
          const map = {};
          list.forEach(u => {
            if (u && u.id != null) map[Number(u.id)] = u;
          });
          setUsersById(prev => ({ ...prev, ...map }));
        }
      } catch (e) {
        console.error('MissedCallsNotifications: failed to load users', e);
      }
    };

    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(missed)]);

  if (!missed.length) return null;

  // показываем максимум 3 уведомления
  const topMissed = missed
    .slice()
    .sort((a, b) => b.count - a.count)
    .slice(0, 3);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {topMissed.map(item => {
        const user = usersById[item.userId] || {};
        const name =
          user.username ||
          [user.first_name, user.last_name].filter(Boolean).join(' ') ||
          `ID ${item.userId}`;
        const avatarUrl = user.avatar || user.avatar_url;

        return (
          <div
            key={item.userId}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              background: 'rgba(15,23,42,0.95)',
              borderRadius: 14,
              padding: '10px 12px 10px 14px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.35)',
              border: '1px solid rgba(248, 113, 113, 0.7)',
              pointerEvents: 'auto'
            }}
          >
            <Avatar
              size="38px"
              online={false}
              style={{
                overflow: 'hidden',
                background: '#1f2937',
                borderRadius: '50%'
              }}
            >
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt={name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '50%'
                  }}
                />
              ) : (
                <span style={{ fontSize: '0.85rem' }}>
                  {(name || '?').charAt(0).toUpperCase()}
                </span>
              )}
            </Avatar>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div
                style={{
                  color: '#e5e7eb',
                  fontWeight: 600,
                  fontSize: '1.02rem',
                  marginBottom: 2,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
                title={name}
              >
                {name}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: '0.96rem',
                  color: '#fed7aa'
                }}
              >
                <FiPhone
                  size={16}
                  style={{
                    color: '#fb923c',
                    transform: 'rotate(135deg)'
                  }}
                />
                <span>Пропущенных звонков: {item.count}</span>
              </div>
            </div>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                dispatch({ type: 'RESET_MISSED_CALLS', payload: { userId: item.userId } });
              }}
              style={{
                border: 'none',
                background: 'transparent',
                color: '#f97373',
                cursor: 'pointer',
                padding: 4,
                borderRadius: 999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              aria-label="Закрыть уведомление о пропущенных звонках"
            >
              <FiX size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
}

